// extracted by mini-css-extract-plugin
export default {"headerWrap":"OnlinePdf_headerWrap__+ND3-","headerWrapInner":"OnlinePdf_headerWrapInner__7Zd07"};